import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LogoMark } from "./Logo";

const LINKS = [
  { id: "about", label: "About" },
  { id: "music", label: "Music" },
  { id: "cinematic", label: "Visuals" },
  { id: "contact", label: "Contact" },
];

const Header = ({ onNav }) => {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    onNav(id);
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-[60] bg-ink/80 backdrop-blur-md border-b border-cream/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-logo-button"
          onClick={() => go("top")}
          className="flex items-center gap-3 group"
          aria-label="Back to top"
        >
          <LogoMark className="w-8 h-8 transition-transform duration-500 group-hover:rotate-[8deg]" />
          <span className="font-display font-medium tracking-[0.35em] text-xs text-cream group-hover:text-gold transition-colors duration-300">
            DANI&nbsp;MORR
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10" data-testid="desktop-nav">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              onClick={() => go(l.id)}
              className="font-mono text-[11px] uppercase tracking-[0.25em] text-cream/60 hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-inquire-button"
            onClick={() => go("contact")}
            className="font-mono text-[11px] uppercase tracking-[0.25em] text-ink bg-gold px-5 py-2.5 rounded-full hover:bg-amber hover:text-cream transition-colors duration-300"
          >
            Inquire
          </button>
        </nav>

        <button
          data-testid="mobile-menu-button"
          className="md:hidden text-cream"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-nav"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35 }}
            className="md:hidden overflow-hidden bg-surface/95 backdrop-blur-md border-t border-cream/10"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`mobile-nav-${l.id}-link`}
                  onClick={() => go(l.id)}
                  className="text-left font-serif text-2xl text-cream/80 hover:text-gold transition-colors"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
